import React, { memo, useMemo } from "react";
import { useTheme } from "@mui/material/styles";
import {
  AppBar,
  Box,
  Stack,
  Toolbar,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { ReactComponent as Logo } from "../../assets/svg/logo.svg";
import CustomButton from "../common/Button";
import { Link } from "react-router-dom";

const TopBar = memo(
  ({
    pathname,
    mobileMenuOpen,
    toggleMobileMenu,
    navigationSections,
    navigationLoading,
  }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const navigationButtons = useMemo(() => {
      if (!navigationSections || navigationLoading) return null;

      return navigationSections.map((section) => {
        const isSelected =
          pathname === section.path || pathname.startsWith(`${section.path}/`);

        return (
          <CustomButton
            key={section.key}
            text={section.title}
            path={section.path}
            isSelected={isSelected}
          />
        );
      });
    }, [navigationSections, navigationLoading, pathname]);

    const logoComponent = useMemo(
      () => (
        <Link to="/" className="logo-link">
          <Logo className="logo" />
        </Link>
      ),
      [],
    );

    const mobileMenuButton = useMemo(
      () => (
        <IconButton
          onClick={toggleMobileMenu}
          size="large"
          className="menu-button"
          aria-label="toggle menu"
        >
          <MenuIcon />
        </IconButton>
      ),
      [toggleMobileMenu]
    );

    if (navigationLoading) {
      return null;
    }

    return (
      <Box className="topbar-container">
        <AppBar className="topbar">
          <Toolbar className="topbar-toolbar">
            <Stack className="topbar-content">
              {isMobile ? (
                <>
                  {mobileMenuButton}
                  {logoComponent}
                  <Box className="spacer" />
                </>
              ) : (
                <>
                  {logoComponent}
                  <Stack className="navigation-buttons">
                    {navigationButtons}
                  </Stack>
                </>
              )}
            </Stack>
          </Toolbar>
        </AppBar>
      </Box>
    );
  },
);

TopBar.displayName = "TopBar";

export default TopBar;